import { Component, Input } from '@angular/core';
import { ModalComponent } from '@appShared/components/modal/modal.component';
import { IStock } from '@appShared/interfaces/[Model-based]/stock.interface';
import { StockEditComponent } from './stock-edit.component';

@Component({
  template: `
    <app-modal title="Stock Pricing for {{stock?.year}}" [showFooter]="false">
      <app-stock-edit
        [stock]="stock"
        (stockUpdated)="refreshGrid()">
      </app-stock-edit>
    </app-modal>`,
   imports: [ModalComponent, StockEditComponent]
})
export class StockEditModalComponent {
  @Input() stock: IStock;
  @Input() refreshGrid: () => void;

  constructor() {}
}
